import React, { ReactNode, useMemo } from "react";
import { useSelector } from "react-redux";

interface RootState {
  userAccess: {
    accessKeys: Record<string, boolean>;
  };
}

interface AccessControlWrapperProps {
  permissionKey: string | string[];
  children: ReactNode;
}

const AccessControlWrapper = React.memo(({ permissionKey, children }: AccessControlWrapperProps) => {
  const userAccess = useSelector((state: RootState) => state.userAccess);

  const checkAccess = useMemo(() => {
    if (!permissionKey) return true;
    const accessKeys = userAccess.accessKeys;
    if (Array.isArray(permissionKey)) {
      return permissionKey.some((key) => accessKeys[key] || false);
    } else if (typeof permissionKey === "string") {
      return accessKeys[permissionKey] || false;
    }
    return false;
  }, [permissionKey, userAccess]);

  return checkAccess ? <>{children}</> : null;
});

export default AccessControlWrapper;
